function Comparativa() {
    return (
        <>
            <object data="https://eurus.energynebula.com/grafana/d-solo/Vw8cv9mHk/scada-solar-ct-pcs?orgId=1&from=now-720m&to=now&theme=light&panelId=2&refresh=1m" width="100%" height="400" frameborder="0"></object>
            <object data="https://eurus.energynebula.com/grafana/d-solo/Vw8cv9mHk/scada-solar-ct-pcs?orgId=1&from=now-720m&to=now&theme=light&panelId=4&refresh=1m" width="100%" height="400" frameborder="0"></object>
        </>
    )
}

export default Comparativa;